import { render, staticRenderFns } from "./DataTableWithCardResult.vue?vue&type=template&id=76326b31&scoped=true&lang=pug"
import script from "./DataTableWithCardResult.vue?vue&type=script&lang=js"
export * from "./DataTableWithCardResult.vue?vue&type=script&lang=js"
import style0 from "./DataTableWithCardResult.vue?vue&type=style&index=0&id=76326b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76326b31",
  null
  
)

export default component.exports